var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Spinner } from 'shared/components';
import { DateTime } from 'luxon';
import { useFormContext } from 'react-hook-form';
import { useRedirectToInteractions } from '../hooks';
import { useUnscheduledNoteForPathContext } from '../contexts';
import { TrackedLinkClick } from 'shared/features/analytics/components/TrackedClick/trackedLinkClick';
export var DeleteNoteButton = function (_a) {
    var isLoading = _a.isLoading, onRequireConfirmation = _a.onRequireConfirmation;
    var form = useFormContext();
    var noteId = useUnscheduledNoteForPathContext().noteId;
    var redirect = useRedirectToInteractions();
    var onDelete = function () {
        var _a;
        // If note is not saved and nothing is touched, or date is only one touched and set to today (default value)
        var numTouchedFields = Object.keys(form.formState.touchedFields).length;
        if (!noteId &&
            (!numTouchedFields ||
                (numTouchedFields === 1 &&
                    form.formState.touchedFields.interactionDate &&
                    DateTime.fromJSDate((_a = form.getValues().interactionDate) !== null && _a !== void 0 ? _a : new Date()).hasSame(DateTime.local(), 'day')))) {
            redirect();
        }
        else {
            onRequireConfirmation();
        }
    };
    return (_jsx(TrackedLinkClick, __assign({ eventName: "Delete Note", eventProperties: {
            spring_doc_id: 'compass010',
        } }, { children: _jsx(Button, __assign({ variant: "redLinks", p: 0, onClick: onDelete, "data-testid": "deleteNote" }, { children: isLoading ? (_jsxs(_Fragment, { children: [_jsx(Spinner, {}), "Deleting"] })) : (_jsx(_Fragment, { children: "Delete note" })) })) })));
};
